import _getIterator from 'babel-runtime/core-js/get-iterator';
export default function conditionallyLoadAnalytics(_ref) {
  var writeKey = _ref.writeKey,
      destinations = _ref.destinations,
      destinationPreferences = _ref.destinationPreferences,
      isConsentRequired = _ref.isConsentRequired,
      _ref$shouldReload = _ref.shouldReload,
      shouldReload = _ref$shouldReload === undefined ? true : _ref$shouldReload;
  var integrations = {
    All: false,
    'Segment.io': true
  };
  var isAnythingEnabled = false;

  if (!destinationPreferences) {
    if (isConsentRequired) {
      return;
    } // Load a.js normally when consent isn't required and there's no preferences


    if (!window.analytics.initialized) {
      window.analytics.load(writeKey);
    }

    return;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(destinations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var destination = _step.value;
      var isEnabled = Boolean(destinationPreferences[destination.id]);

      if (isEnabled) {
        isAnythingEnabled = true;
      }

      integrations[destination.id] = isEnabled;
    } // Reload the page if the trackers have already been initialised so that
    // the user's new preferences can take affect

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (window.analytics.initialized) {
    if (shouldReload) {
      window.location.reload();
    }

    return;
  } // Don't load a.js at all if nothing has been enabled


  if (isAnythingEnabled) {
    window.analytics.load(writeKey, {
      integrations: integrations
    });
  }
}